import { EApiCallStateNames, EBitfApiSortDirection } from '@enums';
import { IBitfApiCallState } from '@interfaces';
import { DefaultApiCallStateMapper } from './default-api-call-state.mapper';

import {
  BitfPFormItemConfigApiRequestPart,
  BitfPPaginationApiRequestPart,
  BitfPSortApiRequestPart,
} from '@common/libs/bitforce/core/api-call-state/bitf-p-api-call-state';

export const apiCallStateConfig = [
  {
    apiCallStateName: EApiCallStateNames.TICKET_REPORTS,

    requestParts: [
      new BitfPFormItemConfigApiRequestPart(),
      new BitfPPaginationApiRequestPart({
        initialPagination: { page: 0, size: 20 },
        options: { pageSizeOptions: [10, 20, 30, 50, 100, 500, 1000], pageIndexOffset: 0 },
      }),
      new BitfPSortApiRequestPart({
        defaultPartData: { data: { property: 'timeStamp', direction: EBitfApiSortDirection.DESC } },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.RIDES_REPORTS,

    requestParts: [new BitfPFormItemConfigApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.VOUCHER_REPORTS,

    requestParts: [new BitfPFormItemConfigApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.RIDE_PASSENGERS_REPORTS,

    requestParts: [new BitfPFormItemConfigApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
